export default "__VITE_ASSET__28c5a5a1__"